import {
    LIQUID_BOTTLE_HAS_ERRORED,
    LIQUID_BOTTLE_FETCH_DATA_SUCCESS,
    CLEAR_LIQUID_BOTTLE,
    LIQUID_BOTTLE_TAKE_HAS_ERRORED,
    LIQUID_BOTTLE_TAKE_SUCCESS,
    LIQUID_BOTTLE_RELEASE_HAS_ERRORED,
    LIQUID_BOTTLE_RELEASE_SUCCESS,
    SET_MY_LIQUID_BOTTLES,
    IS_LOADING,
    GET_LIQUID_BOTTLE_ASSIGNED_TO_ME,
} from "./liquidBottlesConstants";
import { throwSuccessMessage, throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import {
    addSearchHistoryLine,
    getSearchHistoryType,
} from "../searchHistory/searchHistoryActions";
import { LIQUID_BOTTLE_CODE } from "../searchHistory/searchHistoryConstants";

export function clearLiquidBottle() {
    return {
        type: CLEAR_LIQUID_BOTTLE,
        liquidBottle: null,
    };
}

function getMyLiquidBottlesAction(myLiquidBottles) {
    return {
        type: SET_MY_LIQUID_BOTTLES,
        myLiquidBottles,
    };
}

export function liquidBottleHasErrored(bool) {
    return {
        type: LIQUID_BOTTLE_HAS_ERRORED,
        hasErrored: bool,
    };
}

export function liquidBottleIsLoading(bool) {
    return {
        type: IS_LOADING,
        isLoading: bool,
    };
}

export function liquidBottleFetchDataSuccess(liquidBottle) {
    return {
        type: LIQUID_BOTTLE_FETCH_DATA_SUCCESS,
        liquidBottle: liquidBottle,
    };
}

export function getLiquidBottlesAssignedToMeActions(liquidBottlesAssignedToMe) {
    return {
        type: GET_LIQUID_BOTTLE_ASSIGNED_TO_ME,
        liquidBottlesAssignedToMe,
    };
}

export function liquidBottleFetchData(bottleCode) {
    return (dispatch) => {
        dispatch(liquidBottleIsLoading(true));
        dispatch(liquidBottleHasErrored(false));

        dispatch(
            addSearchHistoryLine(getSearchHistoryType(LIQUID_BOTTLE_CODE), bottleCode)
        );

        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/liquid/bottle/" + bottleCode, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                dispatch(liquidBottleIsLoading(false));
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((liquidBottle) => {
                liquidBottle.code = bottleCode;
                dispatch(liquidBottleFetchDataSuccess(liquidBottle));
            })
            .catch((err) => {
                console.error(
                    "Erreur : liquidBottlesActions - liquidBottleFetchData",
                    err
                );
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Ce code bouteille est introuvable !",
                    })
                );
                dispatch(liquidBottleHasErrored(true));
                dispatch(liquidBottleIsLoading(false));
            });
    };
}

export function liquidBottleTakeHasErrored(bool) {
    return {
        type: LIQUID_BOTTLE_TAKE_HAS_ERRORED,
        hasErrored: bool,
    };
}

export function liquidBottleTakeIsLoading(bool) {
    return {
        type: IS_LOADING,
        isLoading: bool,
    };
}

export function liquidBottleTakeSuccess() {
    return {
        type: LIQUID_BOTTLE_TAKE_SUCCESS,
    };
}

export function liquidBottleTakeFetch(userId, EmpId, code) {
    return (dispatch) => {
        dispatch(liquidBottleTakeIsLoading(true));
        dispatch(liquidBottleTakeHasErrored(false));

        let data = {
            user_id: userId,
            emp_id: EmpId,
            code: code,
        };
        let headers = new Headers({ "Content-Type": "application/json" });
        let body = JSON.stringify(data);
        fetchWithTimeout("/api/v1/liquid/bottle/take", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(liquidBottleTakeIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(() => {
                dispatch(liquidBottleTakeSuccess());
                dispatch(
                    throwSuccessMessage({
                        title: "Opération effectuée",
                        message: "La bouteille vous est maintenant assignée",
                    })
                );
                dispatch(liquidBottleFetchData(code));
            })
            .catch((err) => {
                console.error("Erreur : liquidBottlesActions - liquidBottleTakeFetch");
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Impossible d'assigner la bouteille !",
                    })
                );
                dispatch(liquidBottleTakeHasErrored(true));
                dispatch(liquidBottleTakeIsLoading(false));
            });
    };
}

/*  LIQUID BOTTLE RELEASE */
export function liquidBottleReleaseHasErrored(bool) {
    return {
        type: LIQUID_BOTTLE_RELEASE_HAS_ERRORED,
        hasErrored: bool,
    };
}

export function liquidBottleReleaseIsLoading(bool) {
    return {
        type: IS_LOADING,
        isLoading: bool,
    };
}

export function liquidBottleReleaseSuccess() {
    return {
        type: LIQUID_BOTTLE_RELEASE_SUCCESS,
    };
}

export function liquidBottleReleaseFetch(userId, EmpId, code) {
    return (dispatch) => {
        dispatch(liquidBottleReleaseIsLoading(true));
        dispatch(liquidBottleReleaseHasErrored(false));

        let data = {
            user_id: userId,
            emp_id: EmpId,
            code: code,
        };

        let headers = new Headers({ "Content-Type": "application/json" });
        let body = JSON.stringify(data);
        fetchWithTimeout("/api/v1/liquid/bottle/release", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(liquidBottleReleaseIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(() => {
                dispatch(liquidBottleReleaseSuccess());
                dispatch(
                    throwSuccessMessage({
                        title: "Opération effectuée",
                        message: "La bouteille ne vous est plus assignée",
                    })
                );
                dispatch(liquidBottleFetchData(code));
            })
            .catch((err) => {
                console.error(
                    "Erreur : liquidBottlesActions - liquidBottleReleaseFetch"
                );
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la désassignation de la bouteille !",
                    })
                );
                dispatch(liquidBottleReleaseHasErrored(true));
                dispatch(liquidBottleReleaseIsLoading(false));
            });
    };
}
export function getMyLiquidBottles(user, discreet) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout(
            "/api/v1/liquid_bottles/get_my_liquid_bottles/" + user.emp_id,
            {
                method: "GET",
                headers: headers,
            }
        )
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((myLiquidBottles) => {
                dispatch(getMyLiquidBottlesAction(myLiquidBottles));
                dispatch(getLiquidBottlesAssignedToMe(user, myLiquidBottles));
            })
            .catch((err) => {
                console.error(
                    "Erreur : liquidBottlesActions - getMyLiquidBottles",
                    err
                );
                if (!discreet)
                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message:
                                "Erreur lors de la récupération de mes bouteilles de fluide !",
                        })
                    );
            });
    };
}

export function getLiquidBottlesAssignedToMe(user, allMyLiquidBottles) {
    return (dispatch) => {
        let liquidBottlesAssignedToMe = allMyLiquidBottles.filter(
            (lb) => lb.emp_id === user.emp_id
        );
        dispatch(getLiquidBottlesAssignedToMeActions(liquidBottlesAssignedToMe));
    };
}
